export default __webpack_public_path__ + "static/media/Vivofoot.1d5e2401.jpg";